<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="HconsultoriosNutricionales">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>CONSULTORIOS NUTRICIONALES</h1>
                    <p>Una buena alimentación es importante para el cuidado de la salud, con la que podemos incluso prevenir algunas enfermedades.<br/><br/>
                        Por ello Fundación Best cuenta con este servicio en algunas localidades para que puedas atender tu estado nutricional.</p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>
<div id="Fmap">
    <div class="FcfrCst">
        <div class="FcfrCstInt flx dSieteM dtDiez dmDoce">
            <div class="dDoce dmOnce FdirAzul">
                <div class="FformContacto dDoce">
                    <form class="flx">
                        <div class="cttInp dCuatro dtDoce dmDoce">
                            <label for="correo">ESTADO</label>
                            <select ngModel="estado" name="estadoId" (ngModelChange)="getCiudades($event)"
                                class="form-control" required>
                                <option [ngValue]=""  selected>Seleccione Estado</option>
                                <option *ngFor="let estado of estados" [ngValue]="estado.idestado"> {{ estado.nombre | uppercase}}
                                </option>
                            </select>
                        </div>
                        <div class="cttInp dCuatro dtDoce dmDoce">
                            <label for="correo">MUNICIPIO O ALCALDÍA</label>
                            <select ngModel="ciudad" name="ciudadId" (ngModelChange)="selectCiudad($event)"
                                class="form-control" required (click)="activo='seleccionado'">
                                <option [ngValue]=""  selected disabled>Seleccione una Municipio o Alcaldía</option>
                                <option *ngFor="let ciudad of ciudades" [ngValue]="ciudad"> {{ ciudad.nombre | uppercase}}
                                </option>
                            </select>
                        </div>
                        <!-- <div class="cttInp dCuatro dmDoce" *ngIf="this.okmun">
                            <label for="correo">Sucursal</label>
                            <select ngModel="sucursal" name="sucursalId" (ngModelChange)="getprocedimientos($event)"
                                class="form-control" required>
                                <option [ngValue]=""  selected>Seleccione una Sucursal</option>
                                <option *ngFor="let consultorio of consultorios" [ngValue]="consultorio"> {{ consultorio.sucursal | uppercase}}
                                </option>
                            </select>
                        </div> -->
                    </form>
                    <div class="dDiez dmDoce FtbRst flx"  *ngIf="this.espec">
                        <p *ngIf="dataesp.calle?.length > 0">Calle: {{dataesp.calle}}</p>
                        <p *ngIf="dataesp.numeroExterior?.length > 0">Número Exterior: {{dataesp.numeroExterior}}</p>
                        <p *ngIf="dataesp.numeroInterior?.length > 0">Número Interior: {{dataesp.numeroInterior}}</p>
                        <p *ngIf="dataesp.codigoPostal?.length > 0"> Código Postal: {{dataesp.codigoPostal}}</p>
                    </div>
                    <div class="dDiez dmDoce FtbRst flx"  *ngIf="this.dont">
                        <p>Por el momento no tenemos cobertura en su zona</p>
                    </div>
                    <!-- <button type="button" class="btn enviar"><a href="#">CONSULTAR COSTOS</a></button> -->
                </div>
            </div>
        </div>
    </div>
    <div class="espacioDefault"></div>
    <!--Aquí va el mapa-->

    <div class="Fmapa dNueve dtDiez dmOnce maxCnt">
        <div class="map-container">
            <div *ngIf="!geopotitonok" class="mapCover"></div>
            <div id="mapnu" class="map-card"></div>
        </div> 
    </div>
    <!------->

    <div class="FlstDr">
        <table class="Ftabla dOcho dtDiez dmOnce">
            <tr id="tbTitle" class="tbTitle" [ngStyle]="this.showpro === true ? {'display': 'flex'}:{'display': 'none'}">
                <th class="dSeis">TIPO DE SERVICIO</th>
                <th class="dSeis">PRECIO</th>
            </tr>
        </table>
        <table class="Ftabla dOcho dtDiez dmOnce" *ngIf="this.showpro">    
            <tbody *ngFor="let procedimiento of procedimientos">
                <tr>
                    <td [ngStyle]="{'background-color':getColor(procedimiento.tecnica)}">{{procedimiento.tecnica}}</td>
                    <td>{{procedimiento.precio | currency}}</td>
                </tr>
                <tr></tr>
            </tbody>
        </table>
        <p id="Fresponsable" class="Fresponsable" [ngStyle]="this.showpro === true ? {'display': 'flex'}:{'display': 'none'}">Responsable sanitario: Dr. Ángel Gracia Ramírez Céd. Prof: 0753913-UNAM</p>
    </div>
</div>
</div>